import script from "./migrationTransfer.vue?vue&type=script&setup=true&lang=js"
export * from "./migrationTransfer.vue?vue&type=script&setup=true&lang=js"

import "./migrationTransfer.vue?vue&type=style&index=0&id=22dc206a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22dc206a"]])

export default __exports__